import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Sidebar from "@/components/dashboard/Sidebar";
import CompanyNotificationBell from "@/components/dashboard/CompanyNotificationBell";
import { useAuth } from "@/context/AuthContext";

export default function DashboardLayout() {
    const [open, setOpen] = useState(false);
    const { user } = useAuth();

    // Role-based landing: a medarbejder belongs in the mobile employee section.
    if ((user?.role || "").toLowerCase() === "medarbejder") {
        return <Navigate to="/medarbejder" replace />;
    }

    return (
        <div data-testid="dashboard-layout" className="min-h-screen bg-slate-50">
            {/* Mobile top bar */}
            <div className="lg:hidden sticky top-0 z-30 bg-white border-b border-slate-200/70 h-14 flex items-center justify-between px-4">
                <button
                    onClick={() => setOpen(true)}
                    data-testid="dashboard-mobile-toggle"
                    className="inline-flex items-center justify-center w-10 h-10 rounded-lg border border-slate-200 hover:bg-slate-50"
                    aria-label="Åbn menu"
                >
                    <Menu className="w-5 h-5" />
                </button>
                <span className="text-sm font-semibold text-slate-700">MyServiceHelper</span>
                <CompanyNotificationBell />
            </div>

            <div className="flex">
                {/* Desktop sidebar */}
                <div className="hidden lg:block sticky top-0 h-screen">
                    <Sidebar />
                </div>

                {/* Mobile sidebar drawer */}
                {open && (
                    <div className="lg:hidden fixed inset-0 z-40">
                        <div className="absolute inset-0 bg-black/30" onClick={() => setOpen(false)} />
                        <div className="absolute left-0 top-0 bottom-0 w-64 bg-white shadow-2xl">
                            <button
                                onClick={() => setOpen(false)}
                                className="absolute top-4 right-4 w-9 h-9 inline-flex items-center justify-center rounded-lg hover:bg-slate-100"
                                aria-label="Luk menu"
                            >
                                <X className="w-5 h-5" />
                            </button>
                            <Sidebar onNavigate={() => setOpen(false)} />
                        </div>
                    </div>
                )}

                {/* Main content */}
                <main className="flex-1 min-w-0">
                    {/* Desktop notification bell — floating top-right */}
                    <div className="hidden lg:block fixed top-4 right-6 z-30">
                        <CompanyNotificationBell />
                    </div>
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
